export default __webpack_public_path__ + "img/3fdb42ac73d7dd75883615811f63bff3.png";